import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AppRoutes } from './app.routes';
import { authGuard } from './core/authentication/auth.guard';
import { AccountResolver } from './core/resolvers/account.resolver';

const routes: Routes = [
  {
    path: AppRoutes.Start,
    loadChildren: () => import('./features/start/start.module').then(m => m.StartPageModule)
  },
  {
    path: AppRoutes.Courier,
    loadChildren: () => import('./features/courier/courier.module').then(m => m.CourierPageModule),
    canActivate: [authGuard()],
    resolve: { account: AccountResolver }
  },
  {
    path: AppRoutes.Call,
    loadChildren: () => import('./features/call/call.module').then(m => m.CallModule),
    resolve: { account: AccountResolver }
  },
  {
    path: '', redirectTo: AppRoutes.Courier, pathMatch: 'full'
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
